import {Action} from '@ngrx/store';
import { AnamneseOrcadentUploadType, AnamneseUploadType } from 'libs/media/src/lib/models/media.model';
import { ProductKey, ProductOptions } from 'libs/product/src/lib/models/product.model';
import { SapShippingCostItem } from 'libs/sap/src/lib/models/sap.model';

export enum AnamneseActionTypes {
	JawToggled = '[Anamnese] Jaw Toggled',
	BothJawsUpdated = '[Anamnese] Both Jaws Updated',
	ToothAreaUpdated = '[ToothAreaUpdatedAction] Tootharea Updated',
	PatientSelected = '[Anamnese] Patient Selected',
	ProductSelected = '[Anamnese] Product Selected',
	OptionsUpdated = '[Anamnese] Options Updated',
	QuestionaireUpdated = '[Anamnese] Questionaire Updated',
	QuestionaireAnswersUpdated = '[Anamnese] Questionaire Answers Updated',
	QuestionairePreparedAnswersUpdated = '[Anamnese] Questionaire Prepared Answers Updated',
	ClearAnamneseRequested = '[Anamnese] Clear Anamnese',
	ClearAnamneseUploadedFilesRequested ="[Anamnese] Clear Anamnese Uploaded Media Files",
	ClearQuestionaireRequested = '[Anamnese] Questionaire Clear',
	SettingsUpdated = '[Anamnese] Settings Updated',
	HandlingUpdated = '[Anamnese] Handling Updated',
	TreatmentIdUpdated = '[Anamnese] Treatment ID updated',
	MediaFileUploaded ="[Anamnese] Uploaded mediafile",
	MediaFileDeleted ="[Anamnese] Deleted mediafile",
	MediaFileOrcadentUploaded ="[Anamnese] Uploaded orcadent mediafile",
	MediaFileOrcadentDeleted ="[Anamnese] Deleted orcadent mediafile",
	ParentTreatmentSelected = "[Anamnese] Parent Treatment Selected",
	ShippingCostsLoaded = '[Anamnese] Shipping Costs Loaded',
}


export class ClearAnamneseAction implements Action {
	readonly type = AnamneseActionTypes.ClearAnamneseRequested;
}

export class ClearAnamneseUploadedFilesAction implements Action {
	readonly type = AnamneseActionTypes.ClearAnamneseUploadedFilesRequested;
}

export class ToothAreaUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.ToothAreaUpdated;
	constructor( public payload) {}
}
export class JawToggledAction implements Action {
	readonly type = AnamneseActionTypes.JawToggled;
	constructor( public payload) {}
}

export class BothJawsUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.BothJawsUpdated;
	constructor() {}
}
export class PatientSelectedAction implements Action {
	readonly type = AnamneseActionTypes.PatientSelected;
	constructor( public payload) {}
}

export class ProductSelectedAction implements Action {
	readonly type = AnamneseActionTypes.ProductSelected;
	constructor(public payload: { key: ProductKey, options?: ProductOptions }) { }
}
export class OptionsUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.OptionsUpdated;
	constructor( public payload) {}
}
export class QuestionairePreparedAnswersUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.QuestionairePreparedAnswersUpdated;
	constructor( public payload) {}
}
export class QuestionaireAnswersUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.QuestionaireAnswersUpdated;
	constructor( public data, public productKey: ProductKey ) {}
}
export class HandlingUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.HandlingUpdated;
	constructor( public payload) {}
}
export class SettingsUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.SettingsUpdated;
	constructor( public payload) {}
}

export class MediaFileUploadedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileUploaded;
	constructor( public uploadType: AnamneseUploadType, public mediaId: string, public orgFilename: string, public index: number = 0 ) {}
}
export class MediaFileDeletedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileDeleted;
	constructor( public uploadType: AnamneseUploadType, public index: number = 0 ) {}
}
export class MediaFileOrcadentUploadedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileOrcadentUploaded;
	constructor( public uploadType: AnamneseOrcadentUploadType, public mediaId: string, public orgFilename: string) {}
}
export class MediaFileOrcadentDeletedAction implements Action {
	readonly type = AnamneseActionTypes.MediaFileOrcadentDeleted;
	constructor( public uploadType: AnamneseOrcadentUploadType ) {}
}
export class TreatmentIdUpdatedAction implements Action {
	readonly type = AnamneseActionTypes.TreatmentIdUpdated;
	constructor( public payload) {}
}
export class ShippingCostsLoaded implements Action {
	readonly type = AnamneseActionTypes.ShippingCostsLoaded;
	constructor( public payload: {shippingCosts: SapShippingCostItem[]}) {}
}

export class ParentTreatmentSelectedAction implements Action {
	readonly type = AnamneseActionTypes.ParentTreatmentSelected;
	constructor(public payload: { parentTreatmentId: string }) { }
}

export type AnamneseActions =
	| ClearAnamneseAction
	| ClearAnamneseUploadedFilesAction
	| ToothAreaUpdatedAction
	| JawToggledAction
	| BothJawsUpdatedAction
	| PatientSelectedAction
	| ProductSelectedAction
    | OptionsUpdatedAction
	| QuestionairePreparedAnswersUpdatedAction
	| QuestionaireAnswersUpdatedAction
	| HandlingUpdatedAction
	| SettingsUpdatedAction
	| MediaFileUploadedAction
	| MediaFileDeletedAction
	| MediaFileOrcadentUploadedAction
	| MediaFileOrcadentDeletedAction
	| ParentTreatmentSelectedAction
	| TreatmentIdUpdatedAction
	| ShippingCostsLoaded;

